import { render, staticRenderFns } from "./TransactionAmount.vue?vue&type=template&id=999cf646&scoped=true&"
import script from "./TransactionAmount.vue?vue&type=script&lang=js&"
export * from "./TransactionAmount.vue?vue&type=script&lang=js&"
import style0 from "./TransactionAmount.vue?vue&type=style&index=0&id=999cf646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999cf646",
  null
  
)

export default component.exports